import React from 'react';
import { Tier1SleeveFillStatus } from '../../types/tier1Portfolio';

const STYLES: Record<Tier1SleeveFillStatus, string> = {
  empty: 'bg-gray-100 text-gray-700 border-gray-200',
  partial: 'bg-amber-50 text-amber-900 border-amber-200',
  filled: 'bg-green-50 text-green-800 border-green-200',
};

const LABELS: Record<Tier1SleeveFillStatus, string> = {
  empty: 'Empty',
  partial: 'Partial',
  filled: 'Filled',
};

interface Props {
  status: Tier1SleeveFillStatus;
  needsAdditionalUsd?: number;
}

const FillStatusBadge: React.FC<Props> = ({ status, needsAdditionalUsd }) => {
  const title =
    status !== 'filled' && needsAdditionalUsd != null && needsAdditionalUsd > 0
      ? `Need ${needsAdditionalUsd.toLocaleString(undefined, { style: 'currency', currency: 'USD', maximumFractionDigits: 0 })} to target`
      : undefined;

  return (
    <span
      title={title}
      className={`inline-flex rounded-full border px-2 py-0.5 text-xs font-medium ${STYLES[status]}`}
    >
      {LABELS[status]}
    </span>
  );
};

export default FillStatusBadge;
